<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card no-header>
            <b-tabs @input="setTabIndex" justified>
              <b-tab title="Información del Personal" active>
                <b-form-group
                  label="Apellido"
                  label-for="apellido"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="apellido"
                    v-model.trim="$v.apellido.$model"
                    :state="apellidoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="apellidoFeedback">
                    {{ apellidoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Nombre"
                  label-for="nombre"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="nombre"
                    v-model.trim="$v.nombre.$model"
                    :state="nombreValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="nombreFeedback">
                    {{ nombreInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-documento-tipo
                  label="Tipo de Documento"
                  :labelCols="labelCols"
                  :nombre="documentoTipoNombre"
                  :valido="documentoTipoValido"
                  :lista="documentosTiposList"
                  :msjInvalido="documentoTipoInvalidoMsj"
                  @validate="validate"
                  @updated="documentoTipoActualizado">
                </app-documento-tipo>  

                <b-form-group
                  label="Nro. de Documento"
                  label-for="documentoNumero"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="documentoNumero"
                    v-model.trim="$v.documentoNumero.$model"
                    :state="documentoNumeroValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="documentoNumeroFeedback">
                    {{ documentoNumeroInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-estado-civil
                  label="Estado Civil"
                  :labelCols="labelCols"
                  :nombre="estadoCivilNombre"
                  :valido="estadoCivilValido"
                  :lista="estadosCivilesList"
                  :msjInvalido="estadoCivilInvalidoMsj"
                  @validate="validate"
                  @updated="estadoCivilActualizado">
                </app-estado-civil>  

                <b-form-group
                  label="Dirección"
                  label-for="direccion"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="direccion"
                    v-model.trim="$v.direccion.$model"
                    :state="direccionValida"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="direccionFeedback">
                    {{ direccionInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-pais
                  label="Pais"
                  :nombre="paisNombre"
                  :lista="paisesList"
                  :labelCols="labelCols"
                  :nullDisabled="false"
                  labelOption="Seleccione un pais"
                  @updated="paisActualizado">
                </app-pais>  

                <app-provincia
                  label="Provincia"
                  :nombre="provinciaNombre"
                  :lista="provinciasList"
                  :labelCols="labelCols"
                  :nullDisabled="false"
                  labelOption="Seleccione una provincia"
                  @updated="provinciaActualizada">
                </app-provincia>

                <app-localidad
                  label="Localidad"
                  :labelCols="labelCols"
                  :nombre="localidadNombre"
                  :lista="localidadesList"
                  :nullDisabled="false"
                  labelOption="Seleccione una localidad"
                  @updated="localidadActualizada">
                </app-localidad>  

                <b-form-group
                  label="Cod.Postal"
                  label-for="codigoPostal"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="codigoPostal"
                    v-model.trim="$v.codigoPostal.$model"
                    :state="codigoPostalValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="codigoPostalFeedback">
                    {{ codigoPostalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Celular"
                  label-for="celular"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="celular"
                    v-model.trim="$v.celular.$model"
                    :state="celularValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="celularFeedback">
                    {{ celularInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Email"
                  label-for="email"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="email"
                    v-model.trim="$v.email.$model"
                    :state="emailValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="emailFeedback">
                    {{ emailInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Celular Laboral"
                  label-for="celularTrabajo"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="celularTrabajo"
                    v-model.trim="$v.celularTrabajo.$model"
                    :state="celularTrabajoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="celularTrabajoFeedback">
                    {{ celularTrabajoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Email Laboral"
                  label-for="emailTrabajo"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="emailTrabajo"
                    v-model.trim="$v.emailTrabajo.$model"
                    :state="emailTrabajoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="emailTrabajoFeedback">
                    {{ emailTrabajoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Contacto"
                  label-for="contacto"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="contacto"
                    v-model.trim="$v.contacto.$model"
                    :state="contactoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="contactoFeedback">
                    {{ contactoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Tel.Contacto"
                  label-for="telefonoContacto"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="telefonoContacto"
                    v-model.trim="$v.telefonoContacto.$model"
                    :state="telefonoContactoValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="telefonoContactoFeedback">
                    {{ telefonoContactoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Fecha de Nacimiento"
                  label-for="fechaNacimiento"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaNacimientoHabilitada"
                          v-model="fechaNacimientoHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaNacimiento" 
                      v-model="$v.fechaNacimiento.$model" 
                      type="date"
                      :disabled= "fechaNacimientoDisabled"
                      :state="fechaNacimientoValida"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaNacimientoFeedback">
                    {{ fechaNacimientoInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Fecha de Ingreso"
                  label-for="fechaIngreso"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaIngresoHabilitada"
                          v-model="fechaIngresoHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaIngreso"
                      v-model="$v.fechaIngreso.$model"
                      :state="fechaIngresoValida"
                      type="date"
                      :disabled= "fechaIngresoDisabled"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaIngresoFeedback">
                    {{ fechaIngresoInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Fecha de Egreso"
                  label-for="fechaEgreso"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaEgresoHabilitada"
                          v-model="fechaEgresoHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaEgreso"
                      v-model="$v.fechaEgreso.$model"
                      :state="fechaEgresoValida"
                      type="date" 
                      @blur.native="validate"
                      :disabled= "fechaEgresoDisabled">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaEgresoFeedback">
                    {{ fechaEgresoInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-condicion-fiscal
                  label="Condición Fiscal"
                  :labelCols="labelCols"
                  :nombre="condicionFiscalNombre"
                  :valido="condicionFiscalValida"
                  :lista="condicionesFiscalesList"
                  :msjInvalido="condicionFiscalInvalidaMsj"
                  @validate="validate"
                  @updated="condicionFiscalActualizada">
                </app-condicion-fiscal>  

                <app-tipo-identificacion-tributaria
                  label="Tipo Identificación"
                  :labelCols="labelCols"
                  :nombre="tipoIdentificacionTributariaNombre"
                  :valido="tipoIdentificacionTributariaValida"
                  :lista="tiposIdentificacionTributariaList"
                  :msjInvalido="tipoIdentificacionTributariaInvalidaMsj"
                  @validate="validate"
                  @updated="tipoIdentificacionTributariaActualizada">
                </app-tipo-identificacion-tributaria>  

                <b-form-group
                  label="Cod.Identificación"
                  label-for="codigoIdentificacionTributaria"
                  description="Código de identificación tributaria (CUIT, RUT, etc). En caso de CUIT, ingrese sólo dígitos numéricos."
                  :label-cols="labelCols">
                  <b-form-input 
                    id="codigoIdentificacionTributaria"
                    v-model.trim="$v.codigoIdentificacionTributaria.$model"
                    :state="codigoIdentificacionTributariaValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="codigoIdentificacionTributariaFeedback">
                    {{ codigoIdentificacionTributariaInvalidoMsj }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <!-- <b-form-group
                  label="CUIT"
                  label-for="cuit"
                  description="Ingrese sólo números sin guiones ni espacios"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="cuit"
                    v-model.trim="$v.cuit.$model"
                    :state="cuitValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="cuitFeedback">
                    {{ cuitInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group> -->

                <app-banco
                  label="Banco"
                  :labelCols="labelCols"
                  :nombre="bancoNombre"
                  :valido="bancoValido"
                  :lista="bancosList"
                  :msjInvalido="bancoInvalidoMsj"
                  @validate="validate"
                  @updated="bancoActualizado">
                </app-banco>  

                <b-form-group
                  label="Nro.Cuenta"
                  label-for="numeroCuenta"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="numeroCuenta"
                    v-model.trim="$v.numeroCuenta.$model"
                    :state="numeroCuentaValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="numeroCuentaFeedback">
                    {{ numeroCuentaInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="CBU"
                  label-for="cbu"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="cbu"
                    v-model.trim="$v.cbu.$model"
                    :state="cbuValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="cbuFeedback">
                    {{ cbuInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="CBU Alias"
                  label-for="cbuAlias"
                  :label-cols="labelCols">
                  <b-form-input 
                    id="cbuAlias"
                    v-model.trim="$v.cbuAlias.$model"
                    :state="cbuAliasValido"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="cbuAliasFeedback">
                    {{ cbuAliasInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <app-usuario
                  label="Usuario"
                  :labelCols="labelCols"
                  :nombre="usuarioNombre"
                  :valido="usuarioValido"
                  :lista="usuariosList"
                  :msjInvalido="usuarioInvalidoMsj"
                  :nullDisabled="false"
                  @validate="validate"
                  @updated="usuarioActualizado">
                </app-usuario>

                <app-cargo
                  label="Cargo"
                  :labelCols="labelCols"
                  :nombre="cargoNombre"
                  :valido="cargoValido"
                  :lista="cargosList"
                  :msjInvalido="cargoInvalidoMsj"
                  @validate="validate"
                  @updated="cargoActualizado">
                </app-cargo>  

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="externo"
                      v-model="externo"
                      value= true
                      unchecked-value= false>
                      Asesor Externo
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="socio"
                      v-model="socio"
                      value= true
                      unchecked-value= false>
                      Socio
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="facturaHonorarios"
                      v-model="facturaHonorarios"
                      value= true
                      unchecked-value= false>
                      Factura Honorarios
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  v-if="proveedorHabilitado"
                  label="Proveedor"
                  label-for="proveedor"
                  :label-cols="labelCols"
                  horizontal>
                  <b-input-group>
                    <b-input-group-append 
                        class="filter-search-icons" 
                        @click="seleccionarProveedor">
                      <b-input-group-text>
                        <i :class="{ 'fa fa-search': !proveedor,
                                    'fa fa-remove': proveedor  }"></i>
                      </b-input-group-text>
                    </b-input-group-append>
                    <b-form-input 
                      id="proveedor"
                      :value="proveedorNombre"
                      readonly
                      type="text"/>
                  </b-input-group>
                </b-form-group>

                <b-form-group
                  label="Observaciones"
                  label-for="observaciones"
                  :label-cols="labelCols">
                  <b-form-textarea
                    id="observaciones"
                    v-model.trim="$v.observaciones.$model"
                    :state="observacionesValido"
                    :rows="5"
                    :max-rows="10">
                  </b-form-textarea>
                  <b-form-invalid-feedback id="observacionesFeedback">
                    {{ observacionesInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-tab>
              <b-tab title="Grupo Familiar" class="table">
                <b-row class="grupo-familiar">
                  <b-col cols="12" xl="12">
                    <b-table class="datos-objeto" responsive="sm"
                        :items="hijos" 
                        :fields="fieldsHijos"
                        :busy="tableBusy">
                      <div slot="table-busy" class="text-center">
                        <b-spinner variant="primary" label="Spinning" />
                      </div>

                      <template v-slot:cell(fechaNacimiento)="data">
                        {{ data.item.fechaNacimiento | fecha }}
                      </template>            

                      <template v-slot:cell(edad)="data">
                        {{ getEdadHijo(data.item) }}
                      </template>            

                      <template v-slot:cell(opciones)="data">
                        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                          <template slot="button-content">
                            <i class="fa fa-ellipsis-v"></i>
                          </template>
                          <b-dropdown-item @click.stop="editarHijo(data.item)">
                            <i class="fa fa-edit"></i>Editar Datos del Hijo</b-dropdown-item>
                          <b-dropdown-item @click.stop="eliminarHijo(data.item)">
                            <i class="fa fa-times"></i>Eliminar Hijo</b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </b-table>

                    <div class="add-table-btn">
                      <div class="list-add-btn" @click.prevent="agregarHijo">
                          <i class="fa fa-plus" aria-hidden="true"></i>
                      </div>
                    </div>
                  </b-col>
                </b-row> 
                <!-- <b-row>
                  <b-col cols="12" xl="12">
                    <nav>
                      <b-pagination size="sm" 
                        :total-rows="totalRegistrosLegajo" 
                        :per-page="registrosPorPaginaLegajo" 
                        v-model="paginaActualLegajo" prev-text="Prev." next-text="Prox."/>
                    </nav>
                  </b-col>
                </b-row>  -->
              </b-tab>

              <b-tab title="Herramientas" class="table">
                <b-form-group
                  horizontal>
                  <b-form-checkbox 
                      id="silla"
                      v-model="silla"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Silla
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  horizontal>
                  <b-form-checkbox 
                      id="mouse"
                      v-model="mouse"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Mouse
                  </b-form-checkbox>
                </b-form-group>

                <b-form-group
                  horizontal>
                  <b-form-checkbox 
                      id="headset"
                      v-model="headset"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                      Headset
                  </b-form-checkbox>
                </b-form-group>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="searchProveedorModal" 
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="hijoModal"
        title="Datos del Hijo\Hija"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-hijo
        :hijo="hijoSeleccionado"
        @hijoActualizado="hijoActualizado"
        @closeHijo="closeHijo">
      </app-hijo>  
    </b-modal>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import DocumentoTipo from '../shared/abmSelect.vue';
import TipoIdentificacionTributaria from '../shared/abmSelect.vue';
import Pais from '../shared/abmSelect.vue';
import Provincia from '../shared/abmSelect.vue';
import Localidad from '../shared/abmSelect.vue';
import EstadoCivil from '../shared/abmSelect.vue';
import CondicionFiscal from '../shared/abmSelect.vue';
import Banco from '../shared/abmSelect.vue';
import Usuario from '../shared/abmSelect.vue';
import Cargo from '../shared/abmSelect.vue';
import SearchProveedor from '../proveedores/SearchList.vue'
import Hijo from './Hijo.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { required, requiredIf, maxLength, numeric, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personal/getField',
  mutationType: 'personal/updateField',
});

const CodigoIdentificacionValido = ((value, vm) => {
  if (value == '') {
    return true;
  } else {

    /* Sólo validamos el formato del CUIT */
    let isValid = true;
    switch (vm.tipoIdentificacionTributariaId) {
      case 2:
        /* Cuit (11 digitos numéricos) */
        if (isNaN(parseInt(value))) {
          isValid = false;
        } else {
          let length = Math.log(value) * Math.LOG10E + 1 | 0;  
          if (length != 0 & length != 11) {
            isValid = false;
          }
        }
        break;

      // case 4:
      //   /* TIN / EIN  (9 digitos numéricos) */
      //   if (isNaN(parseInt(value))) {
      //     isValid = false;
      //   } else {
      //     let length = Math.log(value) * Math.LOG10E + 1 | 0;  
      //     if (length != 0 & length != 9) {
      //       isValid = false;
      //     }
      //   }
      //   break;
    }
    return isValid;
  }
})

const validCBU = ((value) => {
  if (value == '') {
    return true
  } else {
    if (isNaN(parseInt(value))) {
      return false
    } else {
      if (value.length == 0 || value.length == 22)
        return true
      else
        return false
    }
  }
});

export default {
  name: 'PersonalABM',
  components: {
    appABMButton: ABMButtons,
    appDocumentoTipo: DocumentoTipo,
    appTipoIdentificacionTributaria: TipoIdentificacionTributaria,
    appPais: Pais,
    appProvincia: Provincia,
    appLocalidad: Localidad,
    appEstadoCivil: EstadoCivil,
    appCondicionFiscal: CondicionFiscal,
    appBanco: Banco,
    appUsuario: Usuario,
    appCargo: Cargo,
    appSearchProveedor: SearchProveedor,
    appHijo: Hijo,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      apellidoValido: null,
      apellidoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      documentoTipoValido: null,
      documentoTipoInvalidoMsj: '',
      documentoNumeroValido: null,
      documentoNumeroInvalidoMsj: '',
      // localidadValida: null,
      // localidadInvalidaMsj: '',
      direccionValida: null,
      direccionInvalidaMsj: '',
      codigoPostalValido: null,
      codigoPostalInvalidoMsj: '',
      celularValido: null,
      celularInvalidoMsj: '',
      emailValido: null,
      emailInvalidoMsj: '',
      celularTrabajoValido: null,
      celularTrabajoInvalidoMsj: null,
      emailTrabajoValido: null,
      emailTrabajoInvalidoMsj: '',
      contactoValido: null,
      contactoInvalidoMsj: '',
      telefonoContactoValido: null,
      telefonoContactoInvalidoMsj: '',
      fechaNacimientoValida: null,
      fechaNacimientoInvalidaMsj: '',
      estadoCivilValido: null,
      estadoCivilInvalidoMsj: '',
      fechaIngresoValida: null,
      fechaIngresoInvalidaMsj: '',
      fechaEgresoValida: null,
      fechaEgresoInvalidaMsj: '',
      condicionFiscalValida: null,
      condicionFiscalInvalidaMsj: '',
      tipoIdentificacionTributariaValida: null,
      tipoIdentificacionTributariaInvalidaMsj: '',
      codigoIdentificacionTributariaValido: null,
      codigoIdentificacionTributariaInvalidoMsj: '',
      // cuitValido: null,
      // cuitInvalidoMsj: '',
      bancoValido: null,
      bancoInvalidoMsj: '',
      numeroCuentaValido: null,
      numeroCuentaInvalidoMsj: '',
      cbuValido: null,
      cbuInvalidoMsj: '',
      cbuAliasValido: null,
      cbuAliasInvalidoMsj: '',
      cargoValido: null,
      cargoInvalidoMsj: '',
      usuarioValido: null,
      usuarioInvalidoMsj: '',
      observacionesValido: null,
      observacionesInvalidoMsj: '',

      documentosTipos: [],
      documentosTiposList: [],
      tiposIdentificacionTributaria: [],
      tiposIdentificacionTributariaList: [],
      localidades: [],
      localidadesList: [],
      provincias: [],
      provinciasList: [],
      paises: [],
      paisesList: [],
      estadosCiviles: [],
      estadosCivilesList: [],
      condicionesFiscales: [],
      condicionesFiscalesList: [],
      bancos: [],
      bancosList: [],
      usuarios: [],
      usuariosList: [],
      cargos: [],
      cargosList: [],
      
      loadingPaises: false,
      loadingProvincias: false,
      loadingLocalidades: false,
      fechaNacimientoDisabled: true,
      fechaIngresoDisabled: true,
      fechaEgresoDisabled: true,

      labelCols: 2,
      tabIndex: 0,

      tableBusy: false,

      fieldsHijos: [
        {key: 'apellido'},
        {key: 'nombre'},
        {
          key: 'documentoNumero',
          label: 'Nro. Documento'
        },
        {key: 'fechaNacimiento'},
        {key: 'edad'},
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      hijoSeleccionado: null,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'apellido',
      'nombre',
      'documentoTipo',
      'documentoTipoNombre',
      'documentoNumero',
      'pais',
      'paisNombre',
      'provincia',
      'provinciaNombre',
      'localidad',
      'localidadNombre',
      'direccion',
      'codigoPostal',
      'celular',
      'email',
      'celularTrabajo',
      'emailTrabajo',
      'contacto',
      'telefonoContacto',
      'fechaNacimiento',
      'fechaNacimientoHabilitada',
      'estadoCivil',
      'estadoCivilNombre',
      'fechaIngreso',
      'fechaIngresoHabilitada',
      'fechaEgreso',
      'fechaEgresoHabilitada',
      'condicionFiscal',
      'condicionFiscalNombre',
      'tipoIdentificacionTributaria',
      'tipoIdentificacionTributariaNombre',
      'codigoIdentificacionTributaria',
      // 'cuit',
      'bancoNombre',
      'numeroCuenta',
      'cbu',
      'cbuAlias',
      'cargo',
      'cargoNombre',
      'externo',
      'socio',
      'facturaHonorarios',
      'proveedor',
      'proveedorNombre',
      'silla',
      'mouse',
      'headset',
      'observaciones',
      'hijos',
      'usuarioId',
      'usuario',
      'usuarioNombre',
    ]),
    proveedorHabilitado() {
      return (/true/i).test(this.facturaHonorarios);
    }
  },
  created() {
    let personalId= 0;
    if (this.$route.params){
      if (this.$route.params.id){
        personalId = this.$route.params.id;
      }
    }

    this.loadingPaises = true;
    this.loadingProvincias = true;
    this.loadingLocalidades = true;

    this.getDatosAdicionales();

    this.showSpinner();
    this.$store.dispatch('personal/inicializar', personalId)
      .then (() => {
        this.getPaises();

        if (moment(this.fechaNacimiento).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaNacimientoDisabled = true;
        } else {
          this.fechaNacimientoDisabled = false;
        }
        if (moment(this.fechaIngreso).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaIngresoDisabled = true;
        } else {
          this.fechaIngresoDisabled = false;
        }
        if (moment(this.fechaEgreso).format('YYYY-MM-DD') == '1900-01-01') {
          this.fechaEgresoDisabled = true;
        } else {
          this.fechaEgresoDisabled = false;
        }

        if (this.usuarioId != 0) {
          let exists = this.usuarios.findIndex(t => t.id == this.usuarioId);
          if (exists == -1) {
            this.usuarios.push(this.usuario);
            this.usuariosList.push(this.usuarioNombre)
          }
        }
      })
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    getDatosAdicionales() {
      const vm = this;

      this.$store.dispatch('documentostipos/getListPersonales')
        .then(() => {
          vm.documentosTipos = this.$store.getters['documentostipos/listPersonales'];
          vm.documentosTiposList = this.$store.getters['documentostipos/selectListPersonales'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de tipos de documento.')));

      this.$store.dispatch('documentostipos/getListFiscales')
        .then(() => {
          vm.tiposIdentificacionTributaria = this.$store.getters['documentostipos/listFiscales'];
          vm.tiposIdentificacionTributariaList = this.$store.getters['documentostipos/selectListFiscales'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de tipos de identificación tributaria.')));
        
      this.$store.dispatch('estadosCiviles/getList')
        .then(() => {
          vm.estadosCiviles = this.$store.getters['estadosCiviles/list'];
          vm.estadosCivilesList = this.$store.getters['estadosCiviles/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de estados civiles.')));

      this.$store.dispatch('condicionesfiscales/getCondicionesFiscales')
        .then(() => {
          vm.condicionesFiscales = this.$store.getters['condicionesfiscales/list'];
          vm.condicionesFiscalesList = this.$store.getters['condicionesfiscales/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de condiciones fiscales.')));

      this.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList'];
          vm.bancosList = this.$store.getters['bancos/bancosSelectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de bancos.')));

      this.$store.dispatch('usuarios/getList')
        .then(() => {
          vm.usuarios = this.$store.getters['usuarios/list'];
          vm.usuariosList = this.$store.getters['usuarios/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de usuarios.')));

      this.$store.dispatch('cargos/getList')
        .then(() => {
          vm.cargos = this.$store.getters['cargos/list'];
          vm.cargosList = this.$store.getters['cargos/selectList'];
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la información de cargos.')));
    },
    getPaises() {
      const vm = this;

      this.$store.dispatch('paises/getPaisesSelect')
        .then(() => {
          vm.paises = this.$store.getters['paises/paisesSelect'];
          vm.paisesList = this.$store.getters['paises/listSelect'];
          vm.loadingPaises = false;
          return;
        })
        .then(() => this.getProvincias())
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de paises.'));
    },
    getProvincias() {
      this.provincias = [];
      this.provinciasList = [];

      if (this.paisNombre)
      {
        let pais = this.getSelected(this.paises, this.paisNombre);
        if (pais)
        {
          this.$store.dispatch('provincias/getList', pais.id)
            .then(() => {
              this.provincias = this.$store.getters['provincias/list']
              this.provinciasList = this.$store.getters['provincias/selectList']
              this.loadingProvincias = false;
            })
            .then (() => this.getLocalidades())
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de provincias.'));
        }
      }
    },
    getLocalidades() {
      this.localidades = [];
      this.localidadesList = [];

      if (this.provinciaNombre)
      {
        let provincia = this.getSelected(this.provincias, this.provinciaNombre);
        if (provincia)
        {
          this.$store.dispatch('localidades/getLocalidadesProvincia', provincia.id)
            .then(() => {
              this.localidades = this.$store.getters['localidades/localidadesProvincia'];
              this.localidadesList = this.$store.getters['localidades/localidadesProvinciaList'];
              this.loadingLocalidades = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de localidades.'));
        }
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'apellido' || validarTodos) {
        if (this.$v.apellido.$error) {
          this.apellidoValido = false
          if (!this.$v.apellido.required) {
            this.apellidoInvalidoMsj = 'Debe ingresar el apellido'
          } else if (!this.$v.apellido.maxLength) {
            this.apellidoInvalidoMsj = 'El apellido sólo puede contener hasta 50 caracteres'
          }      
        } else {
          this.apellidoValido = null;
          this.apellidoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj = 'Debe ingresar el nombre'
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre sólo puede contener hasta 50 caracteres'
          }      
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }

      if (campo == 'direccion' || validarTodos) {
        if (this.$v.direccion.$error) {
          this.direccionValida = false
          if (!this.$v.direccion.maxLength) {
            this.direccionInvalidaMsj = 'La dirección sólo puede contener hasta 150 caracteres';
          }      
        } else {
          this.direccionValida = null;
          this.direccionInvalidaMsj = '';
        }
      }

      if (campo == 'codigoPostal' || validarTodos) {
        if (this.$v.codigoPostal.$error) {
          this.codigoPostalValido = false
          if (!this.$v.codigoPostal.maxLength) {
            this.codigoPostalInvalidoMsj = 'El código postal sólo puede contener hasta 10 caracteres';
          }      
        } else {
          this.codigoPostalValido = null;
          this.codigoPostalInvalidoMsj = '';
        }
      }

      if (campo == 'celular' || validarTodos) {
        if (this.$v.celular.$error) {
          this.celularValido = false
          if (!this.$v.celular.maxLength) {
            this.celularInvalidoMsj = 'El número de celular sólo puede contener hasta 25 caracteres';
          }      
        } else {
          this.celularValido = null;
          this.celularInvalidoMsj = '';
        }
      }

      if (campo == 'email' || validarTodos) {
        if (this.$v.email.$error) {
          this.emailValido = false
          if (!this.$v.email.email) {
            this.emailInvalidoMsj = 'El email ingresado no parece ser una dirección de correo válida';
          } else if (!this.$v.email.maxLength) {
            this.emailInvalidoMsj = 'El email sólo puede contener hasta 60 caracteres';
          }      
        } else {
          this.emailValido = null;
          this.emailInvalidoMsj = '';
        }
      }

      if (campo == 'numeroCuenta' || validarTodos) {
        if (this.$v.numeroCuenta.$error) {
          this.numeroCuentaValida = false
          if (!this.$v.numeroCuenta.maxLength) {
            this.numeroCuentaInvalidaMsj = 'El número de cuenta bancaria sólo puede contener hasta 20 caracteres';
          }      
        } else {
          this.numeroCuentaValida = null;
          this.numeroCuentaInvalidaMsj = '';
        }
      }

      if (campo == 'cbu' || validarTodos) {
        if (this.$v.cbu.$error) {
          this.cbuValido = false
          if (!this.$v.cbu.numeric) {
            this.cbuInvalidoMsj = 'El CBU sólo puede contener números';
          } else if (!this.$v.cbu.validCBU) {
            this.cbuInvalidoMsj = 'El número de CBU debe contener 22 dígitos';
          }      
        } else {
          this.cbuValido = null;
          this.cbuInvalidoMsj = '';
        }
      }

      if (campo == 'cbuAlias' || validarTodos) {
        if (this.$v.cbuAlias.$error) {
          this.cbuAliasValido = false
          if (!this.$v.cbuAlias.maxLength) {
            this.cbuAliasInvalidoMsj = 'El alias de CBU sólo puede contener hasta 50 caracteres';
          }      
        } else {
          this.cbuAliasValido = null;
          this.cbuAliasInvalidoMsj = '';
        }
      }

      if (campo == 'documentoNumero' || validarTodos) {
        if (this.$v.documentoNumero.$error) {
          this.documentoNumeroValido = false
          if (!this.$v.documentoNumero.required) {
            this.documentoNumeroInvalidoMsj = 'Debe ingresar el número de documento';
          } else if (!this.$v.documentoNumero.numeric) {
            this.documentoNumeroInvalidoMsj = 'El número de documento sólo puede contener números';
          }
        } else {
          this.documentoNumeroValido = null;
          this.documentoNumeroInvalidoMsj = '';
        }
      }

      if (campo == 'codigoIdentificacionTributaria' || validarTodos) {
        if (this.$v.codigoIdentificacionTributaria.$error) {
          this.codigoIdentificacionTributariaValido = false;
          if (!this.$v.codigoIdentificacionTributaria.required) {
            this.codigoIdentificacionTributariaInvalidoMsj = 'Debe ingresar el código de identificación tributaria';
          } else if (!this.$v.codigoIdentificacionTributaria.CodigoIdentificacionValido) {
            this.codigoIdentificacionTributariaInvalidoMsj = 'Verifique por favor el código de identificación ingresado';
          } else if (!this.$v.codigoIdentificacionTributaria.maxLength) {
            this.codigoIdentificacionTributariaInvalidoMsj = 'El código de identificación solo puede contener hasta 20 caracteres';
          }      
        } else {
          this.codigoIdentificacionTributariaValido = null;
          this.codigoIdentificacionTributariaInvalidoMsj = '';
        }
      }

      // if (campo == 'cuit' || validarTodos) {
      //   if (this.$v.cuit.$error) {
      //     this.cuitValido = false
      //     if (!this.$v.cuit.required) {
      //       this.cuitInvalidoMsj = 'Debe ingresar el CUIT de la persona';
      //     } else if (!this.$v.cuit.numeric) {
      //       this.cuitInvalidoMsj = 'El número de CUIT sólo puede contener números';
      //     }      
      //   } else {
      //     this.cuitValido = null;
      //     this.cuitInvalidoMsj = '';
      //   }
      // }

      if (campo == 'celularTrabajo' || validarTodos) {
        if (this.$v.celularTrabajo.$error) {
          this.celularTrabajoValido = false
          if (!this.$v.celularTrabajo.maxLength) {
            this.celularTrabajoInvalidoMsj = 'El número de celular laboral sólo puede contener hasta 25 caracteres';
          }      
        } else {
          this.celularTrabajoValido = null;
          this.celularTrabajoInvalidoMsj = '';
        }
      }

      if (campo == 'emailTrabajo' || validarTodos) {
        if (this.$v.emailTrabajo.$error) {
          this.emailTrabajoValido = false
          if (!this.$v.emailTrabajo.email) {
            this.emailTrabajoInvalidoMsj = 'El email laboral ingresado no parece ser una dirección de correo válida';
          } else if (!this.$v.emailTrabajo.maxLength) {
            this.emailTrabajoInvalidoMsj = 'El email laboral sólo puede contener hasta 60 caracteres';
          }      
        } else {
          this.emailTrabajoValido = null;
          this.emailTrabajoInvalidoMsj = '';
        }
      }

      if (campo == 'contacto' || validarTodos) {
        if (this.$v.contacto.$error) {
          this.contactoValido = false
          if (!this.$v.contacto.maxLength) {
            this.contactoInvalidoMsj = 'El nombre del contacto sólo puede contener hasta 50 caracteres';
          }      
        } else {
          this.contactoValido = null;
          this.contactoInvalidoMsj = '';
        }
      }

      if (campo == 'telefonoContacto' || validarTodos) {
        if (this.$v.telefonoContacto.$error) {
          this.telefonoContactoValido = false
          if (!this.$v.telefonoContacto.maxLength) {
            this.telefonoContactoInvalidoMsj = 'El número de teléfono del contacto sólo puede contener hasta 25 caracteres';
          }      
        } else {
          this.telefonoContactoValido = null;
          this.telefonoContactoInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValido = false
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidoMsj = 'Las observaciones sólo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValido = null;
          this.observacionesInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let documentoTipo = null;
      if (this.documentoTipoNombre) {
        documentoTipo = this.getSelected(this.documentosTipos, this.documentoTipoNombre);
      }
      this.$store.dispatch('personal/setDocumentoTipo', documentoTipo);
      
      let errorDocumentoTipo = true;
      if (this.documentoTipo) {
        if (this.documentoTipo.id) {
          if (this.documentoTipo.id != 0) {
            errorDocumentoTipo = false;
          }
        }
      }
      if (errorDocumentoTipo) {
        save = false;
        this.documentoTipoValido = false;
        this.documentoTipoInvalidoMsj = 'Debe seleccionar el tipo de documento';
      }

      let estadoCivil = null;
      if (this.estadoCivilNombre) {
        estadoCivil = this.getSelected(this.estadosCiviles, this.estadoCivilNombre);
      }
      this.$store.dispatch('personal/setEstadoCivil', estadoCivil);

      let errorEstadoCivil = true;
      if (this.estadoCivil) {
        if (this.estadoCivil.id) {
          if (this.estadoCivil.id != 0) {
            errorEstadoCivil = false;
          }
        }
      }
      if (errorEstadoCivil) {
        save = false;
        this.estadoCivilValido = false;
        this.estadoCivilInvalidoMsj = 'Debe seleccionar el estado civil';
      }

      let condicionFiscal = null;
      if (this.condicionFiscalNombre) {
        condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
      }
      this.$store.dispatch('personal/setCondicionFiscal', condicionFiscal);

      let errorCondicionFiscal = true;
      if (this.condicionFiscal) {
        if (this.condicionFiscal.id) {
          if (this.condicionFiscal.id != 0) {
            errorCondicionFiscal = false;
          }
        }
      }
      if (errorCondicionFiscal) {
        save = false
        this.condicionFiscalValida = false;
        this.condicionFiscalInvalidaMsj = 'Debe seleccionar la condición fiscal';
      }

      let tipoIdentificacionTributaria = null;
      if (this.tipoIdentificacionTributariaNombre) {
        tipoIdentificacionTributaria = this.getSelected(this.tiposIdentificacionTributaria, this.tipoIdentificacionTributariaNombre);
      }
      this.$store.dispatch('personal/setTipoIdentificacionTributaria', tipoIdentificacionTributaria);

      let tipoIdentificacionTributariaError = Boolean(true);
      if (this.tipoIdentificacionTributaria) {
        if (this.tipoIdentificacionTributaria.id) {
          if (this.tipoIdentificacionTributaria.id != 0) {
            tipoIdentificacionTributariaError = Boolean(false);
          }
        }
      }
      if (tipoIdentificacionTributariaError) {
        save = Boolean(false);
        this.tipoIdentificacionTributariaValida = false;
        this.tipoIdentificacionTributariaInvalidaMsj = 'Debe seleccionar el tipo de identificación.';
      }

      let banco = null;
      if (this.bancoNombre) {
        banco = this.getSelected(this.bancos, this.bancoNombre);
      }
      this.$store.dispatch('personal/setBanco', banco);

      let usuario = null;
      if (this.usuarioNombre) {
        usuario = this.getSelected(this.usuarios, this.usuarioNombre);
      }
      this.$store.dispatch('personal/setUsuario', usuario);

      let cargo = null;
      if (this.cargoNombre) {
        cargo = this.getSelected(this.cargos, this.cargoNombre);
      }
      this.$store.dispatch('personal/setCargo', cargo);

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('personal/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    goList() {
      this.$router.push({ name: "Personal" })
    },
    documentoTipoActualizado(documentoTipoNombre) {
      this.documentoTipoNombre = documentoTipoNombre;
      this.documentoTipoValido = null;
      this.documentoTipoInvalidoMsj = '';
    },
    tipoIdentificacionTributariaActualizada(tipoIdentificacionTributariaNombre) {
      this.tipoIdentificacionTributariaNombre = tipoIdentificacionTributariaNombre;
      if (this.tipoIdentificacionTributariaNombre) {
        this.tipoIdentificacionTributariaValida = null;
        this.tipoIdentificacionTributariaInvalidaMsj = '';
      }
    },
    paisActualizado(paisNombre) {
      if (!this.loadingPaises) {
        let pais = null;
        if (paisNombre) {
          pais = this.getSelected(this.paises, paisNombre);
        }
        this.$store.dispatch('personal/setPais', pais);

        this.getProvincias();
        this.getLocalidades();
      }
    },
    provinciaActualizada(provinciaNombre) {
      if (!this.loadingProvincias) {
        let provincia = null;
        if (provinciaNombre) {
          provincia = this.getSelected(this.provincias, provinciaNombre);
        }
        this.$store.dispatch('personal/setProvincia', provincia);

        this.getLocalidades();

        // this.provinciaValida = null;
        // this.provinciaInvalidaMsj = '';
      }
    },
    localidadActualizada(localidadNombre) {
      if (!this.loadingLocalidades) {
        let localidad = null;
        if (localidadNombre) {
          localidad = this.getSelected(this.localidades, localidadNombre);
        }
        this.$store.dispatch('personal/setLocalidad', localidad);

        // this.localidadValida = null;
        // this.localidadInvalidaMsj = '';
      }
    },
    estadoCivilActualizado(estadoCivilNombre) {
      this.estadoCivilNombre = estadoCivilNombre;
      
      this.estadoCivilValido = null;
      this.estadoCivilInvalidoMsj = '';
    },
    condicionFiscalActualizada(condicionFiscalNombre) {
      this.condicionFiscalNombre = condicionFiscalNombre;
      
      this.condicionFiscalValida = null;
      this.condicionFiscalInvalidaMsj = '';
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;
    },
    usuarioActualizado(usuarioNombre) {
      this.usuarioNombre = usuarioNombre;
      
      this.usuarioValido = null;
      this.usuarioInvalidoMsj = '';
    },
    cargoActualizado(cargoNombre) {
      this.cargoNombre = cargoNombre;
      
      this.cargoValido = null;
      this.cargoInvalidoMsj = '';
    },
    seleccionarProveedor() {
      if (this.proveedor) {
        this.$store.dispatch('personal/setProveedor');
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide();

      this.$store.dispatch('personal/setProveedor', item);
    },
    agregarHijo() {
      this.hijoSeleccionado = null;
      this.$store.dispatch('personal/seleccionarHijo', null)
        .then(() => this.$refs.hijoModal.show());
    },
    editarHijo(hijo) {
      this.hijoSeleccionado = hijo;
      this.$store.dispatch('personal/seleccionarHijo', hijo)
        .then(() => this.$refs.hijoModal.show());
    },
    hijoActualizado(hijo) {
      // console.log(hijo);
      this.$store.dispatch('personal/actualizarHijo', hijo);
      this.$refs.hijoModal.hide();
    },
    closeHijo() {
      this.$refs.hijoModal.hide();
    },
    getEdadHijo(hijo) {
      return moment(hijo.fechaNacimiento).format('YYYY-MM-DD') == '1900-01-01' ? '' : hijo.edad;
    },
    eliminarHijo(hijo) {
      this.showModalConfirm('¿Desea eliminar la información del hijo o hija seleccionado?', 
        this.eliminar.bind(this, hijo), 'Si', null, 'No')
    },
    eliminar(hijo) {
      this.$store.dispatch('personal/eliminarHijo', hijo);
    }
  },
  watch: {
    'fechaNacimientoHabilitada' : function(newVal, oldVal) {
      this.fechaNacimientoDisabled = !(/true/i).test(this.fechaNacimientoHabilitada);
    },
    'fechaIngresoHabilitada' : function(newVal, oldVal) {
      this.fechaIngresoDisabled = !(/true/i).test(this.fechaIngresoHabilitada);
    },
    'fechaEgresoHabilitada' : function(newVal, oldVal) {
      this.fechaEgresoDisabled = !(/true/i).test(this.fechaEgresoHabilitada);
    },
  },
  /* Vuelidate */
  validations: {
    apellido: {
      required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(50)
    },
    direccion: {
      maxLength: maxLength(150)
    },
    codigoPostal: {
      maxLength: maxLength(10)
    },
    celular: {
      maxLength: maxLength(25)
    },
    email: {
      email,
      maxLength: maxLength(60)
    },
    celularTrabajo: {
      maxLength: maxLength(25)
    },
    emailTrabajo: {
      email,
      maxLength: maxLength(60)
    },
    contacto: {
      maxLength: maxLength(50)
    },
    telefonoContacto: {
      maxLength: maxLength(25)
    },
    fechaIngreso: {},
    fechaNacimiento: {},
    fechaEgreso: {},
    documentoNumero: {
      required,
      numeric
    },
    numeroCuenta: {
      maxLength: maxLength(20)
    },
    cbu: {
      numeric,
      validCBU
    },
    cbuAlias: {
      maxLength: maxLength(50)
    },
    codigoIdentificacionTributaria: {
      required: requiredIf(function () {
        var isRequired = true;

        if (this.condicionFiscalNombre) {
          var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
          if (condicionFiscal) {
            if (condicionFiscal.id == 3 || condicionFiscal.id == 4) {
              isRequired = false;
            }
          }
        }
        return isRequired;
      }),
      CodigoIdentificacionValido,
      maxLength: maxLength(20)
    },    
    // cuit: {
    //   required: requiredIf(function () {
    //     var isRequired = true;

    //     if (this.condicionFiscalNombre) {
    //       var condicionFiscal = this.getSelected(this.condicionesFiscales, this.condicionFiscalNombre);
    //       if (condicionFiscal) {
    //         if (condicionFiscal.id == 3 || condicionFiscal.id == 4) {
    //           isRequired = false;
    //         }
    //       }
    //     }
    //     return isRequired;
    //   }),
    //   numeric
    // },
    observaciones: {
      maxLength: maxLength(5000)
    }
  },  
}
</script>

<style>
  /* .grupo-familiar {
    margin-top: 30px;
  } */
  .grupo-familiar .table th {
    border-top: none;
  }
  .grupo-familiar .table td {
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
  }
</style>
